/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
    SourceContactTagToJSONTyped,
} from './SourceContactTag';

/**
 * 
 * @export
 * @interface BulkUpdateSourceContactTagsRequest
 */
export interface BulkUpdateSourceContactTagsRequest {
    /**
     * 
     */
    tags: Array<SourceContactTag>;
}

/**
 * Check if a given object implements the BulkUpdateSourceContactTagsRequest interface.
 */
export function instanceOfBulkUpdateSourceContactTagsRequest(value: object): value is BulkUpdateSourceContactTagsRequest {
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function BulkUpdateSourceContactTagsRequestFromJSON(json: any): BulkUpdateSourceContactTagsRequest {
    return BulkUpdateSourceContactTagsRequestFromJSONTyped(json, false);
}

export function BulkUpdateSourceContactTagsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateSourceContactTagsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tags': ((json['tags'] as Array<any>).map(SourceContactTagFromJSON)),
    };
}

export function BulkUpdateSourceContactTagsRequestToJSON(json: any): BulkUpdateSourceContactTagsRequest {
    return BulkUpdateSourceContactTagsRequestToJSONTyped(json, false);
}

export function BulkUpdateSourceContactTagsRequestToJSONTyped(value?: BulkUpdateSourceContactTagsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tags': ((value['tags'] as Array<any>).map(SourceContactTagToJSON)),
    };
}

